import React from "react";
import PropTypes from 'prop-types';

import { Dropdown } from "../Dropdown/Dropdown";

import "./RangeSelector.scss";

const getDropdownProps = dropdown => {
  const {
    label,
    selectionText,
    ...option
  } = dropdown;

  return ({
    label: selectionText,
    ...option,
  });
}

export const RangeSelector = props => (
  <Dropdown className="range-selector" label={props.label} selectionText={props.selectionText} contentClassName="range-selector__content">  
    {props.dropdowns.map(dropdown => (            
      <div className="range-selector__item" key={dropdown.key}>
        <span className="range-selector__item__label">
          {dropdown.label}
        </span>            
        <Dropdown key={dropdown.key}
            {...getDropdownProps(dropdown)}
            useCarousel={false}
            onChange={option => props.onChange({
              key: dropdown.key,
              selectedOption: option,
            })}              
          />
          <span className="range-selector__item__suffix">
            {dropdown.suffix}
          </span> 
      </div>
    ))}
  </Dropdown>
);

RangeSelector.propTypes = {
  dropdowns: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectionText: PropTypes.element,
};